import React from 'react';

import { CSSTransition } from 'react-transition-group';
import { withStyles, withTheme } from '@glu/theming';
import PropTypes from 'prop-types';

import { JSSClasses } from '../../proptypes/jss-prop-types';

/* istanbul ignore next */
const styles = ({
  transitions: {
    duration: { short },
    easing: { easeInOut }
  }
}) => ({
  slide: {
    '&-enter': {
      transition: `transform ${short}ms ${easeInOut}`,
      display: 'block',
      transform: 'translate(0, 100vh)'
    },

    '&-enter-active': {
      transform: 'translate(0, 0)'
    },

    '&-enter-done': {
      display: 'block'
    },

    '&-exit': {
      transition: `transform ${short}ms ${easeInOut}`,
      display: 'block',
      transform: 'translate(0, 0)'
    },

    '&-exit-active': {
      transform: 'translate(0, 100vh)'
    },

    '&-exit-done': {
      display: 'none'
    }
  }
});

export function SlideComponent({
  children,
  classes: { slide },
  in: show,
  mountOnEnter,
  theme: {
    transitions: {
      duration: { short }
    }
  },
  unmountOnExit
}) {
  return (
    <CSSTransition
      in={show}
      classNames={slide}
      timeout={short}
      mountOnEnter={mountOnEnter}
      unmountOnExit={unmountOnExit}
    >
      {children}
    </CSSTransition>
  );
}

SlideComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.func])),
    PropTypes.element,
    PropTypes.node,
    PropTypes.func
  ]),
  classes: JSSClasses,
  mountOnEnter: PropTypes.bool,
  in: PropTypes.bool,
  theme: PropTypes.shape({}),
  unmountOnExit: PropTypes.bool
};

SlideComponent.defaultProps = {
  children: [],
  classes: {},
  mountOnEnter: true,
  in: false,
  theme: {},
  unmountOnExit: true
};

const SlideStyled = withStyles(styles)(SlideComponent);
export default withTheme(SlideStyled);
